<app-mapa-devices-tab
  [itemCollection]="itemObservable"
  [buttonActive]="true"
  [deviceNavigate]="false"
  [title]="title"
  (itemSelected)="selectedItem($event)"
  (goBack)="goBack()"
  [isRoot]="isRoot"
  (itemUnselected)="unSelectedItem($event)"
  (itemNavigate)="navigate($event)"
  [deviceSettings]="deviceSettings"
  [loading]="loadingChildren"
></app-mapa-devices-tab>
